import React from "react";
import { Card, Form, Row, Col, Image } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const CmPunjabSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value
    });
  };

  const handleFileUpload = async (file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleChange('image', res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">CM Punjab Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange('heading', e.target.value)}
                  placeholder="Enter heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={data.message}
                  onChange={(e) => handleChange('message', e.target.value)}
                  placeholder="Enter message"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Author</Form.Label>
                <Form.Control
                  type="text"
                  value={data.author}
                  onChange={(e) => handleChange('author', e.target.value)}
                  placeholder="Enter author name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Image</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    e.target.files?.[0] && handleFileUpload(e.target.files[0])
                  }
                />
                {isUploading && (
                  <div className="text-muted small mt-1">
                    Uploading...
                  </div>
                )}
                {data.image && (
                  <div className="mt-2">
                    <Image
                      src={data.image}
                      alt="Preview"
                      thumbnail
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default CmPunjabSection;
